module.exports = __webpack_public_path__ + "static/img/page1-bg.a2ec464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page1-bg.png
// module id = 6zyo
// module chunks = 216